<script>
import baseUpload from "components/base-control/modules/base-upload.vue";
function showText(val) {
  if (val === true) return "收起";
  return "展开";
}
export default {
  name: "multiline-search",
  components: {
    baseUpload
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    showIndex: {
      type: Number,
      default: 8
    },
    isSearch: {
      type: Boolean,
      default: true
    },
    useProps: {
      type: Boolean,
      default: false
    },
    isRoot: {
      type: Boolean,
      default: false
    },
    isDipatch: {
      type: Boolean,
      default: false
    },
    dipatchObj: {
      type: Object,
      default: () => {}
    },
    params: {
      type: Object,
      default: () => {}
    },
    searchLoading: {
      type: Boolean,
      default: false
    }
  },
  render(h) {
    return (
      <el-row style="margin-bottom: 10px;">
        <el-row>
          {this.options
            .filter(item => {
              const isShow = typeof item.isShow === "function";
              return isShow ? item.isShow() : item.isShow !== false
            })
            .map((item, $index) => {
              const showIndex =
                this.isSearch === true
                  ? this.isShow
                    ? 99
                    : this.showIndex
                  : 99;
              return $index < showIndex ? (
                item.empty ? <el-col span={item.span ? item.span : 6}><span class="empty-control"></span></el-col> : 
                <el-col span={item.span ? item.span : 6}>
                  <component
                    v-model={item.value}
                    {...{
                      on: item.on ? {...item.on} : {},
                      props: {
                        ...item,
                        disabled:
                          typeof item.disabled === "function"
                            ? item.disabled()
                            : item.disabled
                      },
                      is: item.controlName
                    }}
                  ></component>
                </el-col>
              ) : null;
            })}
        </el-row>
        {this.isSearch === true && (
          <el-row type="flex" justify="end">
            <base-button
              isRoot={this.isRoot}
              onClick={this.handleSearchBtn}
              type="primary"
              size="small"
              loading={this.searchLoading}
            >
              搜索
            </base-button>
            <el-button onClick={this.handleReset} size="small">
              重置
            </el-button>
            {this.showIndex < this.options.length ? (
              <el-button onClick={this.handleShow2Close} size="small">
                {showText(this.isShow)}
              </el-button>
            ) : null}
          </el-row>
        )}
      </el-row>
    );
  },
  methods: {
    showText,
    handleShow2Close() {
      this.isShow = !this.isShow;
    },
    _checkParams() {
      const hasEmpty = this.$utils.formatParamsRequire(this.options);
      if (hasEmpty) {
        this.$message({ type: "warning", message: hasEmpty });
        return false;
      }
      return this.$utils.formatParams(this.options);
    },
    handleGetParams() {
      const params = this._checkParams();
      return params;
    },
    handleSearchBtn() {
      const params = this._checkParams();
      if(params) {
        this.$emit("handleSearch", params);
      }
    },
    handleReset() {
      this.options.forEach(item => {
        item.value = undefined;
      });
      if (this.isDipatch === true) {
        this.options.forEach(item => {
          const propsName = item.propsName;
          if (this.dipatchObj.hasOwnProperty(propsName)) {
            this.$store.dispatch("updateObject", {
              obj: this.dipatchObj,
              attr: propsName,
              val: null
            });
          }
        });
      }
      this.$emit("handleReset");
    }
  },
  data() {
    return {
      isShow: false
    };
  },
  computed: {
  }
};
</script>
<style lang="scss" scoped>
.empty-control {
  display: inline-flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  min-height: 40px;
  font-size: 14px;
  margin-bottom: 10px;
}
</style>
